import { render, staticRenderFns } from "./StudentClassText.vue?vue&type=template&id=1868fe5e&scoped=true&"
import script from "./StudentClassText.vue?vue&type=script&lang=ts&"
export * from "./StudentClassText.vue?vue&type=script&lang=ts&"
import style0 from "./StudentClassText.vue?vue&type=style&index=0&id=1868fe5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868fe5e",
  null
  
)

export default component.exports